export default __webpack_public_path__ + "static/media/light_dis_message.ea87c1ae.svg";